'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.applyMask = applyMask;
exports.applyValidation = applyValidation;
exports.applyFullValidation = applyFullValidation;
exports.isProfileValid = isProfileValid;
exports.addFocusToFirstInvalidInput = addFocusToFirstInvalidInput;

function applyMask(field, value) {
  return field.mask ? field.mask(value) : value;
}

function applyValidation(field, value) {
  if (!value || !value.trim()) {
    return field.required ? 'EMPTY_FIELD' : null;
  }

  return field.validate && !field.validate(value) || containsEmoji(value) ? 'INVALID_FIELD' : null;
}

function applyFullValidation(rules, profile, isCorporate) {
  var validatedProfile = Object.keys(profile).map(function (field) {
    var _ref2;

    var rule = rules.personalFields.find(function (rule) {
      return rule.name === field;
    }) || rules.businessFields.find(function (rule) {
      return rule.name === field && isCorporate;
    });

    if (rule) {
      var _ref;

      var error = applyValidation(rule, profile[field].value);
      return _ref = {}, _ref[field] = _extends({}, profile[field], {
        error: error
      }), _ref;
    }

    return _ref2 = {}, _ref2[field] = {
      value: null
    }, _ref2;
  }).reduce(function (acc, cur) {
    return _extends({}, acc, cur);
  }, {});
  return addFocusToFirstInvalidInput(rules, validatedProfile);
}

function isProfileValid(profile) {
  return !Object.keys(profile).some(function (field) {
    return profile[field].error != null;
  });
}

function addFocusToFirstInvalidInput(rules, profile) {
  var _extends2;

  var firstInvalidInput = rules.personalFields.find(function (field) {
    return profile[field.name].error != null;
  }) || rules.businessFields.find(function (field) {
    return profile[field.name].error != null;
  });
  if (firstInvalidInput == null) return profile;

  var focusedInput = _extends({}, profile[firstInvalidInput.name], {
    focus: true
  });

  return _extends({}, profile, (_extends2 = {}, _extends2[firstInvalidInput.name] = focusedInput, _extends2));
}

function containsEmoji(input) {
  // Emojis until version 11.0
  var EMOJIS_REGEX = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/;
  return EMOJIS_REGEX.test(input);
}